export default __webpack_public_path__ + "static/media/LogoElte2.b6842874.svg";